import React from 'react';
import { OptimizedImage as Image } from '@components/OptimizedImage';

import ThemedIcon from '@components/ThemedIcon';
import { useTheme } from '@context/ThemeProvider';

const defaultSize = 80;

type Props = {
  file: File | null;
  onRemove?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  size?: number;
};

export function FilePreview({ file, onRemove, size }: Props) {
  const { image } = useTheme();
  const fileURL = file ? URL.createObjectURL(file) : image.file;
  const isPDF = file?.type === 'application/pdf';

  const renderFileContent = () => {
    return isPDF ? (
      <div
        className={`padding-[2px] text-file-preview-text flex-col justify-end overflow-hidden text-ellipsis break-all text-center text-[9px]`}
        style={{
          width: '100%',
          height: 40,
        }}
      >
        <Image
          src={image.pdfFile}
          width={24}
          height={24}
          className='mx-auto'
          alt='pdf'
        />
        {file.name}
      </div>
    ) : (
      <Image
        src={fileURL}
        alt='Preview'
        className='h-full w-full rounded object-cover'
        width={size || defaultSize}
        height={size || defaultSize}
      />
    );
  };

  return (
    <div className='relative flex h-[104px] !w-[104px] flex-col items-center justify-center overflow-hidden rounded-lg border border-accent-primary'>
      {renderFileContent()}
      {!!onRemove && (
        <div onClick={onRemove} className='absolute right-2 top-2'>
          <ThemedIcon name='dark-circle-close' width={24} height={24} />
        </div>
      )}
    </div>
  );
}
